import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { IPermission, ILanguages } from './models/map';
import { IPermissionMapping } from './models/user';
import { SetUserLevelPermissions } from './app-store/user/user.action';
import { Store, select } from '@ngrx/store';
import { userDetailsPayload } from './app-store/user/user.selector';
import { Subscription } from 'rxjs';
import { mapsSelector } from './app-store/map/map.selector';
import { TranslocoService } from '@ngneat/transloco';
// import { MsalService } from './msal/services/msal.service';
import { MsalService } from '@azure/msal-angular';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InfoDialogueComponent } from './shared/dialogues/infodialog/infodialog.component';
import { InstalldialogComponent } from './shared/dialogues/installdialog/installdialog.component';
import { PermissionMappingsSelector } from './app-store/user/userPermission.selector';
import { getJsChunkError } from './app.routes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  deferredPrompt;

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    e.preventDefault();
    this.deferredPrompt = e;
    this.openDialog();
  }

  @HostListener('window:mousemove')
  @HostListener('window:keyup')
  resetTimeout() {
    clearTimeout(this.interval);
    this.checkInActivity();
  }

  title = 'HSEGLobal';
  languages: ILanguages[];
  ref: MatDialogRef<InfoDialogueComponent>;
  userDetailsPayload: Subscription;
  interval: any;
  userPermissionMapping: Subscription;
  loadingRouteConfig: boolean;
  constructor(
    private swUpdate: SwUpdate,
    private store: Store,
    private router: Router,
    private dialog: MatDialog,
    private service: TranslocoService,
    private msalService: MsalService) {
  }

  openDialog = () => {
    const ref = this.dialog.open(InstalldialogComponent, {
      disableClose: false,
      data: this.deferredPrompt,
      panelClass: 'custom-dialog-container',
    });
  }

  ngOnInit() {

    this.swUpdate.available.subscribe(response => {
      const ref = this.dialog.open(InfoDialogueComponent, {
        disableClose: true,
        data: { status: this.service.translate('New Version of the Application is available, Refresh now'), fromInactivity: true }
      });
      ref.afterClosed().subscribe(response => {
        window.location.reload()
      });
    });

    getJsChunkError().subscribe(resp => {
      if (resp) {
        this.loadingRouteConfig = false;
        const ref = this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: { status: this.service.translate('Page Load Failed, Refresh to try again'), fromInactivity: true }
        });
        ref.afterClosed().subscribe(response => {
          window.location.reload()
        });
      }
    })

    this.msalService.handleRedirectObservable().subscribe(
      resp => {
        if (resp !== null) {
          this.router.navigateByUrl('/internal');
        }
      },
      err => console.log(err)
    );

    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }
    });

    this.checkInActivity();

    this.userDetailsPayload = this.store.pipe(select(userDetailsPayload)).subscribe(userDetailResponse => {
      this.store.pipe(select(mapsSelector)).subscribe(masterResponse => {
        if (userDetailResponse !== undefined && userDetailResponse.permissionMapping !== undefined
          && masterResponse.payload !== undefined) {
          this.languages = masterResponse.payload.languages;
          if (userDetailResponse.preferredLanguage === undefined) {
            this.service.setActiveLang(this.languages.filter(item => item.name === 'English').map(language => language.culture)[0]);
          } else {
            this.service.setActiveLang(this.languages.filter(item => item.name === userDetailResponse.preferredLanguage).map(language => language.culture)[0]);
          }
        }
      });
    });

    this.userPermissionMapping = this.store.pipe(select(PermissionMappingsSelector)).subscribe(permissionMapping => {
      this.store.pipe(select(mapsSelector)).subscribe(masterResponse => {
        this.setUserPermission(masterResponse.payload?.permissions, permissionMapping);
      });
    });
  }

  // Set User level permission
  setUserPermission = (masterResponse: IPermission[], userDetailResponse: IPermissionMapping[]) => {

    if (masterResponse !== undefined && userDetailResponse !== undefined) {
      const result = masterResponse.filter(masterPermissions =>
        userDetailResponse.some(permission => permission.permissionId === masterPermissions.id)
      );
      this.store.dispatch(SetUserLevelPermissions({ permission: result }));
    }
  }

  checkInActivity = () => {
    this.interval = setTimeout(() => {
      if (this.ref === undefined) {
        this.ref = this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: { status: this.service.translate('You have been inactive for more than 1 hour'), fromInactivity: true }
        });
        this.ref.afterClosed().subscribe(response => {
          window.location.replace(window.location.origin);
        });
      }
    }, 3600000);
  }

  ngOnDestroy() {
    if (this.userPermissionMapping) {
      this.userPermissionMapping.unsubscribe();
    }
    if (this.userDetailsPayload) {
      this.userDetailsPayload.unsubscribe();
    }
  }
}
